<template>
  <div class="main-content">
    <div class="flowLogs-list">
      <div class="title">
        {{ $t("page.prmDetail.operatorLogTitle") }}
      </div>
      <el-table
        :data="operationLogs"
        border
        style="width: 100%; margin-top: 20px; font-size: 14px"
        tooltip-effect="dark"
      >
        <el-table-column
          align="center"
          prop="createUserName"
          :label="$t('page.prmDetail.operator')"
        >
          <template slot-scope="scope">
            {{ scope.row.createUserName }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="fieldName"
          :label="$t('page.prmDetail.fieldName')"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          prop="oldValue"
          :label="$t('page.prmDetail.oldValue')"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in splitStringByComma(scope.row.oldValue)"
              :key="index"
            >
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="newValue"
          :label="$t('page.prmDetail.newValue')"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in splitStringByComma(scope.row.newValue)"
              :key="index"
            >
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="newValue" :label="$t('page.prmDetail.newValue')" /> -->
        <el-table-column
          align="center"
          prop="createTime"
          :label="$t('page.prmDetail.updateTime')"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging" style="text-align: right; margin-top: 20px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      />
    </div>
  </div>
</template>

<script>
import API from "../../API";
import { formate } from "../../libs/mixin";
export default {
  name: "OperationLogs",
  mixins: [formate],
  data() {
    return {
      operationLogs: [],
      page: {
        currentPage: 1,
        pagesize: 10,
        total: 0,
      },
    };
  },
  methods: {
    splitStringByComma(str) {
      if (str !== null) {
        return str.split(",");
      } else {
        return str;
      }
    },
    init() {
      let id = this.$route.query.objectId;
      if (id) {
        this.getOperationpnLogs(id);
      }
    },
    getOperationpnLogs(id) {
      let params = {
        params: {
          objectId: id,
          pageNum: this.page.currentPage,
          pageSize: this.page.pagesize,
        },
      };
      API.getOperationLogs(params)
        .then((res) => {
          // console.log(res.data);
          let json = res.data;
          // console.log(json.data.list);
          if (json.status === "200") {
            this.operationLogs = json.data.list;
            this.page.total = json.data.total;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleSizeChange(val) {
      this.page.pagesize = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
